__turbopack_context__.v({
  "root": "PlasmicSliderThumb-module__GhOena__root",
});
